import { IS_APP } from "@/__main__/constants.mjs";

export const HD = `@media screen and (min-width: 1800px)`;
export const desktop = `@media screen and (max-width: 1339px)`;
export const tabletLarge = `@media screen and (max-width: 1066px)`;
export const tablet = `@media screen and (max-width: 1023px)`;
export const tabletMedium = `@media screen and (max-width: 920px)`;
export const tabletSmall = `@media screen and (max-width: 820px)`;
export const mobile = `@media screen and (max-width: 767px)`;
export const mobileLarge = `@media screen and (max-width: 550px)`;
export const mobileMedium = `@media screen and (max-width: 480px)`;
export const mobileSmall = `@media screen and (max-width: 374px)`;

export const firefoxOnly = `@-moz-document url-prefix()`;
export const mouseOnly = `@media screen and (pointer: fine)`;
export const touchOnly = `@media screen and (pointer: coarse)`;

export const screenNot = (mediaQuery: string) =>
  mediaQuery.replace("media screen and", "media not screen and");

export const anyMedia = (...mediaQueries: string[]) =>
  `@media screen and (${mediaQueries
    .map((mediaQuery) => mediaQuery.replace("@media screen and ", ""))
    .join(" or ")})`;

const TITLE_BAR_HEIGHT = IS_APP ? "var(--sp-11)" : "0";

export const visuallyHidden = `
  position: absolute !important;

  height: 1px;
  width: 1px;

  white-space: nowrap;
  overflow: hidden;

  clip: rect(1px 1px 1px 1px); /* Other browser support */
  clip: rect(1px, 1px, 1px, 1px);
  clip-path: inset(50%);
`;

export const styles = (container: string) => /*css*/ `
:root,
:root *::backdrop {
  /* Sizing/Spacing */
  --unit: 0.25;

  --sp-px: calc(var(--unit) * 0.25rem);
  --sp-0_5: calc(var(--unit) * 0.5rem);
  --sp-1: calc(var(--unit) * 1rem);
  --sp-1_5: calc(var(--unit) * 1.5rem);
  --sp-2: calc(var(--unit) * 2rem);
  --sp-2_5: calc(var(--unit) * 2.5rem);
  --sp-3: calc(var(--unit) * 3rem);
  --sp-3_5: calc(var(--unit) * 3.5rem);
  --sp-4: calc(var(--unit) * 4rem);
  --sp-4_5: calc(var(--unit) * 4.5rem);
  --sp-5: calc(var(--unit) * 5rem);
  --sp-5_5: calc(var(--unit) * 5.5rem);
  --sp-6: calc(var(--unit) * 6rem);
  --sp-6_5: calc(var(--unit) * 6.5rem);
  --sp-7: calc(var(--unit) * 7rem);
  --sp-7_5: calc(var(--unit) * 7.5rem);
  --sp-8: calc(var(--unit) * 8rem);
  --sp-8_5: calc(var(--unit) * 8.5rem);
  --sp-9: calc(var(--unit) * 9rem);
  --sp-9_5: calc(var(--unit) * 9.5rem);
  --sp-10: calc(var(--unit) * 10rem);
  --sp-10_5: calc(var(--unit) * 10.5rem);
  --sp-11: calc(var(--unit) * 11rem);
  --sp-11_5: calc(var(--unit) * 11.5rem);
  --sp-12: calc(var(--unit) * 12rem);
  --sp-12_5: calc(var(--unit) * 12.5rem);
  --sp-13: calc(var(--unit) * 13rem);
  --sp-13_5: calc(var(--unit) * 13.5rem);
  --sp-14: calc(var(--unit) * 14rem);
  --sp-15: calc(var(--unit) * 15rem);
  --sp-16: calc(var(--unit) * 16rem);
  --sp-17: calc(var(--unit) * 17rem);
  --sp-17_5: calc(var(--unit) * 17.5rem);
  --sp-18: calc(var(--unit) * 18rem);
  --sp-19: calc(var(--unit) * 19rem);
  --sp-20: calc(var(--unit) * 20rem);
  --sp-21: calc(var(--unit) * 21rem);
  --sp-22: calc(var(--unit) * 22rem);
  --sp-23: calc(var(--unit) * 23rem);
  --sp-24: calc(var(--unit) * 24rem);
  --sp-25: calc(var(--unit) * 25rem);
  --sp-26: calc(var(--unit) * 26rem);
  --sp-27: calc(var(--unit) * 27rem);
  --sp-28: calc(var(--unit) * 28rem);
  --sp-29: calc(var(--unit) * 29rem);
  --sp-30: calc(var(--unit) * 30rem);
  --sp-31: calc(var(--unit) * 31rem);
  --sp-31_5: calc(var(--unit) * 31.5rem);
  --sp-32: calc(var(--unit) * 32rem);
  --sp-33: calc(var(--unit) * 33rem);
  --sp-36: calc(var(--unit) * 36rem);
  --sp-46: calc(var(--unit) * 46rem);
  --sp-48: calc(var(--unit) * 48rem);

  --sp-pxe: calc(var(--unit) * 0.25em);
  --sp-0_5e: calc(var(--unit) * 0.5em);
  --sp-1e: calc(var(--unit) * 1em);
  --sp-1_5e: calc(var(--unit) * 1.5em);
  --sp-2e: calc(var(--unit) * 2em);
  --sp-2_5e: calc(var(--unit) * 2.5em);
  --sp-2_75e: calc(var(--unit) * 2.75em);
  --sp-3e: calc(var(--unit) * 3em);
  --sp-3_5e: calc(var(--unit) * 3.5em);
  --sp-4e: calc(var(--unit) * 4em);
  --sp-4_5e: calc(var(--unit) * 4.5em);
  --sp-5e: calc(var(--unit) * 5em);
  --sp-5_5e: calc(var(--unit) * 5.5em);
  --sp-6e: calc(var(--unit) * 6em);
  --sp-6_5e: calc(var(--unit) * 6.5em);
  --sp-7e: calc(var(--unit) * 7em);
  --sp-7_5e: calc(var(--unit) * 7.5em);
  --sp-8e: calc(var(--unit) * 8em);
  --sp-8_5e: calc(var(--unit) * 8.5em);
  --sp-9e: calc(var(--unit) * 9em);
  --sp-9_5e: calc(var(--unit) * 9.5em);
  --sp-10e: calc(var(--unit) * 10em);
  --sp-10_5e: calc(var(--unit) * 10.5em);
  --sp-11e: calc(var(--unit) * 11em);
  --sp-12e: calc(var(--unit) * 12em);
  --sp-13e: calc(var(--unit) * 13em);
  --sp-13_5e: calc(var(--unit) * 13em);
  --sp-14e: calc(var(--unit) * 14em);
  --sp-15e: calc(var(--unit) * 15em);
  --sp-16e: calc(var(--unit) * 16em);
  --sp-17e: calc(var(--unit) * 17em);
  --sp-18e: calc(var(--unit) * 18em);
  --sp-19e: calc(var(--unit) * 19em);
  --sp-20e: calc(var(--unit) * 20em);
  --sp-21e: calc(var(--unit) * 21em);
  --sp-22e: calc(var(--unit) * 22em);
  --sp-23e: calc(var(--unit) * 23em);
  --sp-24e: calc(var(--unit) * 24em);
  --sp-25e: calc(var(--unit) * 25em);
  --sp-26e: calc(var(--unit) * 26em);
  --sp-27e: calc(var(--unit) * 27em);
  --sp-28e: calc(var(--unit) * 28em);
  --sp-29e: calc(var(--unit) * 29em);
  --sp-30e: calc(var(--unit) * 30em);
  --sp-31e: calc(var(--unit) * 31em);
  --sp-31_5e: calc(var(--unit) * 31.5em);
  --sp-32e: calc(var(--unit) * 32em);
  --sp-33e: calc(var(--unit) * 33em);
  --sp-46e: calc(var(--unit) * 46em);
  --sp-48e: calc(var(--unit) * 48em);

  /* Border radii */
  --br: 5px;
  --br-xl: 12px;
  --br-lg: 8px;
  --br-sm: 3px;

  /* Colors */
  --hue: 222deg;

  /* Base HSL values */
  --shade0-hsl: var(--hue) 14% 93%;
  --shade1-hsl: var(--hue) 14% 70%;
  --shade2-hsl: var(--hue) 5% 56%;
  --shade3-hsl: var(--hue) 6% 30%;
  --shade4-hsl: var(--hue) 7% 30%;
  --shade5-hsl: var(--hue) 9% 23%;
  --shade6-hsl: var(--hue) 10% 17%;
  --shade7-hsl: var(--hue) 14% 10%;
  --shade8-hsl: var(--hue) 19% 9%;
  --shade9-hsl: var(--hue) 20% 7%;
  --shade10-hsl: var(--hue) 33% 4%;

  --primary-hsl: 352deg 71% 54%;
  --primary-hsl-hover: 352deg 69% 58%;
  --primary: hsla(var(--primary-hsl) / 1);
  --primary-hover: hsla(var(--primary-hsl-hover) / 1);

  --white: hsl(0deg 0% 100%);
  --red-hsl: 360deg 72% 55%;
  --red: hsla(var(--red-hsl) / 1);
  --green-hsl: 142deg 76% 47%;
  --green: hsla(var(--green-hsl) / 1);
  --blue-hsl: 210deg 100% 63%;
  --blue: hsla(var(--blue-hsl) / 1);
  --turq-hsl: 178deg 69% 52%;
  --turq: hsla(var(--turq-hsl) / 1);
  --yellow-hsl: 47deg 89% 55%;
  --yellow: hsla(var(--yellow-hsl) / 1);
  --orange-hsl: 32deg 100% 55%;
  --orange: hsla(var(--orange-hsl) / 1);
  --purple-hsl: 267deg 100% 69%;
  --purple: hsla(var(--purple-hsl) / 1);
  --pink-hsl: 299deg 76% 68%;
  --pink: hsla(var(--pink-hsl) / 1);
  --lime-hsl: 87deg 76% 47%;
  --lime: hsla(var(--lime-hsl) / 1);
  --nav-bar-hsl: var(--hue) 20% 8%;

  --blue-15: hsla(var(--blue-hsl) / 0.15);
  --blue-25: hsla(var(--blue-hsl) / 0.25);
  --blue-50: hsla(var(--blue-hsl) / 0.50);
  --blue-75: hsla(var(--blue-hsl) / 0.75);

  --red-5: hsla(var(--red-hsl) / 0.05);
  --red-15: hsla(var(--red-hsl) / 0.15);
  --red-25: hsla(var(--red-hsl) / 0.25);
  --red-50: hsla(var(--red-hsl) / 0.50);
  --red-75: hsla(var(--red-hsl) / 0.75);

  --turq-5: hsla(var(--turq-hsl) / 0.05);
  --turq-15: hsla(var(--turq-hsl) / 0.15);
  --turq-25: hsla(var(--turq-hsl) / 0.25);
  --turq-50: hsla(var(--turq-hsl) / 0.50);
  --turq-75: hsla(var(--turq-hsl) / 0.75);

  --yellow-15: hsla(var(--yellow-hsl) / 0.15);
  --yellow-25: hsla(var(--yellow-hsl) / 0.25);
  --yellow-50: hsla(var(--yellow-hsl) / 0.50);
  --yellow-75: hsla(var(--yellow-hsl) / 0.75);

  --rank-gold-hsl: 39deg 55% 56%;
  --rank-gold: hsla(var(--rank-gold-hsl) / 1);
  --rank-silver-hsl: 184deg 11% 76%;
  --rank-silver: hsla(var(--rank-silver-hsl) / 1);
  --rank-bronze-hsl: 29deg 29% 52%;
  --rank-bronze: hsla(var(--rank-bronze-hsl) / 1);

  --perf-pos3: hsl(178deg 69% 52%);
  --perf-pos2: hsl(180deg 53% 66%);
  --perf-pos1: hsl(182deg 42% 73%);
  --perf-neutral: hsl(190deg 23% 80%);
  --perf-neg1: hsl(353deg 30% 76%);
  --perf-neg2: hsl(358deg 59% 67%);
  --perf-neg3: hsl(360deg 74% 60%);

  --tier1-hsl: 40deg 90% 55%;
  --tier1: hsla(var(--tier1-hsl) / 1);
  --tier2-hsl: 178deg 69% 52%;
  --tier2: hsla(var(--tier2-hsl) / 1);
  --tier3-hsl: 182deg 42% 73%;
  --tier3: hsla(var(--tier3-hsl) / 1);
  --tier4-hsl: 190deg 23% 80%;
  --tier4: hsla(var(--tier4-hsl) / 1);
  --tier5-hsl: 222deg 7% 37%;
  --tier5: hsla(var(--tier5-hsl) / 1);
  --tierNone-hsl: 222deg 8% 22%;
  --tierNone: hsla(var(--tierNone-hsl) / 1);

  --ap-hsl: 235deg 88% 73%;
  --ap: hsla(var(--ap-hsl) / 1);

  --ad-hsl: 360deg 100% 67%;
  --ad: hsla(var(--ad-hsl) / 1);
  --true: #E4ECEE;

  --subscriber-solid-hsl: 38deg 48% 55%;
  --subscriber-solid: hsla(var(--subscriber-solid-hsl) / 1);
  --subscriber: var(--subscriber-solid);
  --gold: var(--subscriber-solid);
  --subscriber-gradient: linear-gradient(45deg, hsla(37deg 42% 40% / 1) 0%, hsla(39deg 63% 62% / 1) 100%);
  --subscriber-gradient-10: linear-gradient(45deg, hsla(37deg 42% 40% / .10) 0%, hsla(39deg 63% 62% / .10) 100%);
  --subscriber-gradient-15: linear-gradient(45deg, hsla(37deg 42% 40% / .15) 0%, hsla(39deg 63% 62% / .15) 100%);
  --subscriber-gradient-25: linear-gradient(45deg, hsla(37deg 42% 40% / .25) 0%, hsla(39deg 63% 62% / .25) 100%);
  --subscriber-gradient-50: linear-gradient(45deg, hsla(37deg 42% 40% / .50) 0%, hsla(39deg 63% 62% / .50) 100%);
  --cta-gradient: linear-gradient(315deg, #ce0f50 25%, #fe112d 75%);

  /* basic transition curve */
  --ease-out-circ: cubic-bezier(0, 0.55, 0.45, 1);
  --ease-out-quad: cubic-bezier(0.5, 1, 0.89, 1);
  --ease-out-quart: cubic-bezier(0.25, 1, 0.5, 1);
  --ease-in-quart: cubic-bezier(0.5, 0, 0.75, 0);
  --ease-out-expo: cubic-bezier(0.16, 1, 0.3, 1);
  --ease-in-expo: cubic-bezier(0.7, 0, 0.84, 0);
  --ease-out-back: cubic-bezier(0.34, 1.56, 0.64, 1);
  --bezier: var(--ease-out-expo);
  --transition-duration: 0.25s;
  --transition-duration-short: 0.15s;
  --transition-duration-long: 0.6s;
  --transition: var(--transition-duration) var(--bezier);
  --transition-short: var(--transition-duration-short) var(--bezier);
  --transition-long: var(--transition-duration-long) var(--bezier);
}

body {
  /* Primary */
  --primary-15: hsla(var(--primary-hsl) / 0.15);
  --primary-25: hsla(var(--primary-hsl) / 0.25);
  --primary-50: hsla(var(--primary-hsl) / 0.50);

  --turq-15: hsla(var(--turq-hsl) / 0.15);
  --turq-25: hsla(var(--turq-hsl) / 0.25);
  --turq-50: hsla(var(--turq-hsl) / 0.50);
  --turq-75: hsla(var(--turq-hsl) / 0.75);

  /* Shade 0 */
  --shade0: hsla(var(--shade0-hsl) / 1);
  --shade0-15: hsla(var(--shade0-hsl) / 0.15);
  --shade0-25: hsla(var(--shade0-hsl) / 0.25);
  --shade0-50: hsla(var(--shade0-hsl) / 0.5);
  --shade0-75: hsla(var(--shade0-hsl) / 0.75);

  /* Shade 1 */
  --shade1: hsla(var(--shade1-hsl) / 1);
  --shade1-15: hsla(var(--shade1-hsl) / 0.15);
  --shade1-25: hsla(var(--shade1-hsl) / 0.25);
  --shade1-50: hsla(var(--shade1-hsl) / 0.5);
  --shade1-75: hsla(var(--shade1-hsl) / 0.75);

  /* Shade 2 */
  --shade2: hsla(var(--shade2-hsl) / 1);
  --shade2-15: hsla(var(--shade2-hsl) / 0.15);
  --shade2-25: hsla(var(--shade2-hsl) / 0.25);
  --shade2-50: hsla(var(--shade2-hsl) / 0.5);
  --shade2-75: hsla(var(--shade2-hsl) / 0.75);

  /* Shade 3 */
  --shade3: hsla(var(--shade3-hsl) / 1);
  --shade3-15: hsla(var(--shade3-hsl) / 0.15);
  --shade3-25: hsla(var(--shade3-hsl) / 0.25);
  --shade3-50: hsla(var(--shade3-hsl) / 0.5);
  --shade3-75: hsla(var(--shade3-hsl) / 0.75);

  /* Shade 4 */
  --shade4: hsla(var(--shade4-hsl) / 1);
  --shade4-15: hsla(var(--shade4-hsl) / 0.15);
  --shade4-25: hsla(var(--shade4-hsl) / 0.25);
  --shade4-50: hsla(var(--shade4-hsl) / 0.5);
  --shade4-75: hsla(var(--shade4-hsl) / 0.75);

  /* Shade 5 */
  --shade5: hsla(var(--shade5-hsl) / 1);
  --shade5-15: hsla(var(--shade5-hsl) / 0.15);
  --shade5-25: hsla(var(--shade5-hsl) / 0.25);
  --shade5-50: hsla(var(--shade5-hsl) / 0.5);
  --shade5-75: hsla(var(--shade5-hsl) / 0.75);

  /* Shade 6 */
  --shade6: hsla(var(--shade6-hsl) / 1);
  --shade6-15: hsla(var(--shade6-hsl) / 0.15);
  --shade6-25: hsla(var(--shade6-hsl) / 0.25);
  --shade6-50: hsla(var(--shade6-hsl) / 0.5);
  --shade6-75: hsla(var(--shade6-hsl) / 0.75);

  /* Shade 7 */
  --shade7: hsla(var(--shade7-hsl) / 1);
  --shade7-15: hsla(var(--shade7-hsl) / 0.15);
  --shade7-25: hsla(var(--shade7-hsl) / 0.25);
  --shade7-50: hsla(var(--shade7-hsl) / 0.5);
  --shade7-75: hsla(var(--shade7-hsl) / 0.75);

  /* Shade 8 */
  --shade8: hsla(var(--shade8-hsl) / 1);
  --shade8-15: hsla(var(--shade8-hsl) / 0.15);
  --shade8-25: hsla(var(--shade8-hsl) / 0.25);
  --shade8-50: hsla(var(--shade8-hsl) / 0.5);
  --shade8-75: hsla(var(--shade8-hsl) / 0.75);

  /* Shade 9 */
  --shade9: hsla(var(--shade9-hsl) / 1);
  --shade9-15: hsla(var(--shade9-hsl) / 0.15);
  --shade9-25: hsla(var(--shade9-hsl) / 0.25);
  --shade9-50: hsla(var(--shade9-hsl) / 0.5);
  --shade9-75: hsla(var(--shade9-hsl) / 0.75);

  /* Shade 10 */
  --shade10: hsla(var(--shade10-hsl) / 1);
  --shade10-15: hsla(var(--shade10-hsl) / 0.15);
  --shade10-25: hsla(var(--shade10-hsl) / 0.25);
  --shade10-50: hsla(var(--shade10-hsl) / 0.5);
  --shade10-75: hsla(var(--shade10-hsl) / 0.75);

  --highlight: inset 0 1px hsl(0deg 0% 100% / 6%);
  --btn-txt-shadow: 0 2px var(--shade9-25);

  --nav-bar: hsla(var(--nav-bar-hsl));

  --app-bg-hsl: var(--shade9-hsl);
  --app-bg: var(--shade9);

  /* for convenience... */
  margin: 0;
}

*::-webkit-scrollbar {
  width: var(--scrollbar-width);
}

*::-webkit-scrollbar-thumb {
  background-color: var(--shade3-50);
  border-radius: 0;
  border: none;
}

/* THEME VARIATIONS */
.theme-dark {
  --hue: 222deg;

  --shade0-hsl: var(--hue) 14% 93%;
  --shade1-hsl: var(--hue) 14% 70%;
  --shade2-hsl: var(--hue) 5% 56%;
  --shade3-hsl: var(--hue) 6% 30%;
  --shade4-hsl: var(--hue) 7% 30%;
  --shade5-hsl: var(--hue) 9% 23%;
  --shade6-hsl: var(--hue) 10% 17%;
  --shade7-hsl: var(--hue) 14% 11%;
  --shade8-hsl: var(--hue) 19% 9%;
  --shade9-hsl: var(--hue) 20% 7%;
  --shade10-hsl: var(--hue) 33% 4%;
  --nav-bar-hsl: var(--hue) 20% 8%;
}

.theme-blue {
  --hue: 220deg;

  --shade0-hsl: var(--hue) 24% 93%;
  --shade1-hsl: var(--hue) 26% 70%;
  --shade2-hsl: var(--hue) 23% 62%;
  --shade3-hsl: var(--hue) 19% 56%;
  --shade4-hsl: var(--hue) 24% 46%;
  --shade5-hsl: var(--hue) 25% 27%;
  --shade6-hsl: var(--hue) 36% 23%;
  --shade7-hsl: var(--hue) 35% 17%;
  --shade8-hsl: var(--hue) 35% 15%;
  --shade9-hsl: var(--hue) 42% 12%;
  --shade10-hsl: var(--hue) 61% 7%;
  --nav-bar-hsl: var(--hue) 42% 11%;
}

.theme-aubergine {
  --hue: 256deg;

  --shade0-hsl: var(--hue) 24% 93%;
  --shade1-hsl: var(--hue) 26% 70%;
  --shade2-hsl: var(--hue) 23% 62%;
  --shade3-hsl: var(--hue) 19% 56%;
  --shade4-hsl: var(--hue) 24% 46%;
  --shade5-hsl: var(--hue) 25% 27%;
  --shade6-hsl: var(--hue) 36% 23%;
  --shade7-hsl: var(--hue) 35% 17%;
  --shade8-hsl: var(--hue) 35% 15%;
  --shade9-hsl: var(--hue) 42% 12%;
  --shade10-hsl: var(--hue) 61% 7%;
  --nav-bar-hsl: var(--hue) 42% 11%;

  --primary-hsl: var(--green-hsl);
  --primary-hsl-hover: var(--green-hsl);
}

.theme-gherkin {
  --hue: 168deg;

  --shade0-hsl: var(--hue) 24% 93%;
  --shade1-hsl: var(--hue) 26% 70%;
  --shade2-hsl: var(--hue) 23% 62%;
  --shade3-hsl: var(--hue) 19% 56%;
  --shade4-hsl: var(--hue) 24% 46%;
  --shade5-hsl: var(--hue) 25% 27%;
  --shade6-hsl: var(--hue) 36% 23%;
  --shade7-hsl: var(--hue) 35% 17%;
  --shade8-hsl: var(--hue) 35% 15%;
  --shade9-hsl: var(--hue) 42% 12%;
  --shade10-hsl: var(--hue) 61% 7%;
  --nav-bar-hsl: var(--hue) 42% 11%;

  --primary-hsl: var(--green-hsl);
  --primary-hsl-hover: var(--green-hsl);
}

.theme-halloween {
  --hue: 273deg;
  --saturation: 36%;

  --shade0-hsl: var(--hue) var(--saturation) 90%;
  --shade1-hsl: var(--hue) var(--saturation) 75%;
  --shade2-hsl: var(--hue) var(--saturation) 55%;
  --shade3-hsl: var(--hue) var(--saturation) 48%;
  --shade4-hsl: var(--hue) var(--saturation) 35%;
  --shade5-hsl: var(--hue) var(--saturation) 23%;
  --shade6-hsl: var(--hue) var(--saturation) 20%;
  --shade7-hsl: var(--hue) var(--saturation) 16%;
  --shade8-hsl: var(--hue) var(--saturation) 12%;
  --shade9-hsl: var(--hue) var(--saturation) 10%;
  --shade10-hsl: var(--hue) var(--saturation) 7%;
  --nav-bar-hsl: var(--hue) var(--saturation) 11%;

  --primary-hsl: var(--green-hsl);
  --primary-hsl-hover: var(--green-hsl);
}

input {
  background: transparent;
  border: none;
  &:focus {
    outline: none;
  }
}

:where(${container}) {
  --btn-height: var(--sp-9);

  /* App size stuff */
  --sp-container: 66rem;
  --sp-container-gap: 1rem;

  /* Title bar */
  --nav-bg: var(--shade8);
  --title-bar-height: ${TITLE_BAR_HEIGHT};

  *::backdrop {
    --title-bar-height: ${TITLE_BAR_HEIGHT};
  }

  /* Secondary Nav */
  --secondary-nav-height: var(--sp-12);
  --secondary-nav-background-color: transparent;
  --secondary-nav-border-color: transparent;

  font-size: 16px;
  font-family: 'Inter', Arial, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: 400;
  line-height: 1.6;
  color: var(--shade0);

  button,
  input,
  textarea,
  select
  details {
    font-size: inherit;
    font-family: inherit;
    font-weight: inherit;
    color: inherit;
    line-height: 1.6;
  }

  button {
    border: none;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  ol,
  ul,
  menu {
    margin: 0;
    padding: 0;
  }

  ol,
  ul,
  menu {
    list-style: none;
  }

  img {
    display: block;
    height: auto;
    user-select: none;
    user-drag: none;
  }

  svg {
    display: block;
  }

  svg:not(.original-colors) {
    stroke-width: 0;
    stroke: none;
    fill: currentColor;
  }

  ::selection {
    /* WebKit/Blink Browsers */
    background: var(--primary);
    color: var(--white, white);
  }

  .type-body1-form,
  .type-body2-form {
    font-weight: 400;
  }
  .type-caption--semi,
  .type-body1-form--semi,
  .type-body2-form--semi,
  .type-form--button,
  .type-form--tab,
  .type-form--shortcut  {
    font-weight: 500;
  }

  /* TODO (Rio): depricate old fonts like h3/4 subtitle article headline etc */
  .type-subtitle1,
  .type-subtitle2 {
    font-weight: 550;
  }
  .type-h2,
  .type-h3,
  .type-h4,
  .type-h5,
  .type-h6,
  .type-article-headline,
  .type-caption--bold,
  .type-body1-form--active,
  .type-body2-form--active,
  .type-body2-form--bold,
  .type-mini {
    font-weight: 600;
  }

  .type-form--shortcut {
    font-size: calc(var(--sp-1e) * 2.75);
  }
  .type-body2-form,
  .type-body2-form--active,
  .type-subtitle2,
  .type-form--button,
  .type-form--tab  {
    font-size: var(--sp-3_5e);
  }
  .type-body1-form,
  .type-body1-form--active,
  .type-subtitle1,
  .type-title--semi,
  .type-title--bold {
    font-size: var(--sp-4e);
    line-height: var(--sp-7);
  }
  .type-article-headline {
    font-size: var(--sp-4_5e);
  }
  .type-h6 {
    font-size: var(--sp-5e);
  }
  .type-h5 {
    font-size: var(--sp-6e);
  }
  .type-h4 {
    font-size: var(--sp-7e);
  }
  .type-h3 {
    font-size: var(--sp-8e);
  }
  .type-h2 {
    font-size: var(--sp-12);
  }

  /* Page header */
  .type-page-header {
    font-size: 1.5rem;
    line-height: 2.25rem;
    font-weight: 600;
  }
  .type-page-subheader {
    font-size: 1.25rem;
    line-height: 2rem;
    font-weight: 500;
  }

  /* Large title */
  .type-large-title--bold {
    font-size: 1.125rem;
    line-height: 1.75rem;
    font-weight: 600;
  }

  /* Body1 / title */
  .type-body1,
  .type-title,
  .type-title--semi,
  .type-title--bold {
    font-size: 1rem;
    line-height: 1.75rem;
  }
  .type-title--semi {
    font-weight: 500;
  }
  .type-title--bold {
    font-weight: 600;
  }
  .type-body1-form--bold {
    line-height: 1.25;
  }

  /* Body2 / Subtitle */
  .type-body2,
  .type-body2-form--bold,
  .type-subtitle,
  .type-subtitle--semi,
  .type-subtitle--bold {
    font-size: 0.875rem;
    line-height: 1.5rem;
  }
  .type-subtitle--semi {
    font-weight: 500;
  }
  .type-subtitle--bold {
    font-weight: 600;
  }
  .type-body2-form--bold {
    line-height: 1.25rem;
  }

  /* Callout */
  .type-callout,
  .type-callout--semi,
  .type-callout--bold {
    font-size: 0.8125rem;
    line-height: 1.25rem;
  }
  .type-callout--semi {
    font-weight: 500;
  }
  .type-callout--bold {
    font-weight: 600;
  }

  /* Caption */
  .type-caption,
  .type-caption--semi,
  .type-caption--bold {
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1.25rem;
  }
  .type-caption--semi {
    font-weight: 500;
  }
  .type-caption--bold {
    font-weight: 600;
  }

  /* Overline */
  .type-overline {
    font-size: 0.6875rem;
    font-weight: 600;
    letter-spacing: 0.015rem;
    text-transform: uppercase;
  }

  /* Mini TODO (Rio): depricate this */
  .type-mini {
    font-size: 0.6em;
    text-transform: uppercase;
  }

  .text-center {
    text-align: center;
  }

  .text-end {
    text-align: end;
  }

  :where(.card-container) {
    --padd: var(--sp-6);
    --radii: var(--br-lg);
    --surface-2-border-color: var(--shade3-25);
    --card-surface: var(--shade8);
    position: relative;
    background: var(--card-surface);
    border-radius: var(--radii);
    overflow: hidden;
  }
  :where(.card-container)::after {
    content: "";
    position: absolute;
    inset: 0;
    border: 1px solid var(--surface-2-border-color);
    border-radius: var(--radii);
    z-index: 2;
    pointer-events: none;
  }
  :where(.card-container) > * {
    position: relative;
    z-index: 1;
  }

  /* Border radii */
  .br {
    border-radius: var(--br);
  }
  .br-xl {
    border-radius: var(--br-xl);
  }
  .br-lg {
    border-radius: var(--br-lg);
  }
  .br-sm {
    border-radius: var(--br-sm);
  }
  .br-top-none {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  /* Utility */
  .color-shade1 {
    color: var(--shade1);
  }
  .color-shade2 {
    color: var(--shade2);
  }
  .color-shade3 {
    color: var(--shade3);
  }
  .color-shade4 {
    color: var(--shade4);
  }
  .color-shade5 {
    color: var(--shade5);
  }
  .color-shade6 {
    color: var(--shade6);
  }
  .color-shade7 {
    color: var(--shade7);
  }
  .color-shade8 {
    color: var(--shade8);
  }
  .color-shade9 {
    color: var(--shade9);
  }
  .color-shade10 {
    color: var(--shade10);
  }
  .color-blue {
    color: var(--blue);
  }
  .color-red {
    color: var(--red);
  }
  .color-turq {
    color: var(--turq);
  }
  .relative {
    position: relative;
  }
  .absolute {
    position: absolute;
  }
  .absolute.inset-0 {
    inset: 0;
  }
  .left-0 {
    left: 0;
  }
  .top-0 {
    top: 0;
  }
  .right-0 {
    right: 0;
  }
  .bottom-0 {
    bottom: 0;
  }
  .absolute-center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .scroll-y {
    overflow-y: scroll;
    scrollbar-gutter: stable;
  }
  .scroll-x {
    overflow-x: scroll;
  }
  .scrollbar-hidden {
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .overflow-hidden {
    overflow: hidden;
  }
  .overflow-auto {
    overflow: auto;
  }
  .deep-pointer-events-none {
    pointer-events: none;
    * {
      pointer-events: none;
    }
  }
  .container-width {
    max-width: var(--sp-container);
  }
  .side-margin-auto {
    margin-left: auto;
    margin-right: auto;
  }
  .inline-block {
    display: inline-block;
  }
  .display-contents {
    display: contents;
  }
  .pad-0-3 {
    padding: 0 var(--sp-3);
  }
  .pad-0-4 {
    padding: 0 var(--sp-4);
  }
  .pad-0-6 {
    padding: 0 var(--sp-6);
  }
  .pad-1-3 {
    padding: var(--sp-2) var(--sp-3);
  }
  .pad-1 {
    padding: var(--sp-2);
  }
  .pad-2 {
    padding: var(--sp-2);
  }
  .pad-2-0 {
    padding: var(--sp-2) 0;
  }
  .pad-3 {
    padding: var(--sp-3);
  }
  .pad-4 {
    padding: var(--sp-4);
  }
  .pad-6 {
    padding: var(--sp-6);
  }
  .flex {
    display: flex;
  }
  .flex.column {
    flex-direction: column;
  }
  .flex.inline {
    display: inline-flex;
  }
  .flex.align-center {
    align-items: center;
  }
  .flex.align-baseline {
    align-items: baseline;
  }
  .flex.align-start {
    align-items: start;
  }
  .flex.align-end {
    align-items: end;
  }
  .flex.direction-column {
    flex-direction: column;
  }
  .flex.between,
  .flex.justify-between {
    justify-content: space-between;
  }
  .flex.justify-around {
    justify-content: space-around;
  }
  .flex.flex-end,
  .flex.justify-end {
    justify-content: flex-end;
  }
  .flex.flex-start,
  .flex.justify-start {
    justify-content: flex-start;
  }
  .flex.justify-center {
    justify-content: center;
  }
  .flex.wrap {
    flex-wrap: wrap;
  }
  .flex-grow {
    flex-grow: 1;
  }
  .flex-100 {
    flex: 1 0 0px;
    min-width: 0;
  }
  .flex-divider {
    flex: 1 0 100%;
    height: 0px;
  }
  .flex-divider-vertical {
    flex: 1 0 100%;
    width: 0px;
  }
  .flex-align-stretch {
    align-self: stretch;
  }
  .flex.gap-sp-1,
  .flex.gap-1 {
    gap: var(--sp-1);
  }
  .flex.gap-sp-1-5,
  .flex.gap-1-5 {
    gap: var(--sp-1_5);
  }
  .flex.gap-sp-2,
  .flex.gap-2 {
    gap: var(--sp-2);
  }
  .flex.gap-sp-3,
  .flex.gap-3 {
    gap: var(--sp-3);
  }
  .flex.gap-sp-4,
  .flex.gap-4 {
    gap: var(--sp-4);
  }
  .flex.gap-sp-5,
  .flex.gap-5 {
    gap: var(--sp-5);
  }
  .flex.gap-sp-6,
  .flex.gap-6 {
    gap: var(--sp-6);
  }
  .flex.gap-sp-7,
  .flex.gap-7 {
    gap: var(--sp-7);
  }
  .flex.gap-sp-8,
  .flex.gap-8 {
    gap: var(--sp-8);
  }
  .flex.gap-sp-9,
  .flex.gap-9 {
    gap: var(--sp-9);
  }
  .flex.gap-sp-10,
  .flex.gap-10 {
    gap: var(--sp-10);
  }
  .flex.gap-sp-11,
  .flex.gap-11 {
    gap: var(--sp-11);
  }
  .flex.gap-sp-12,
  .flex.gap-12 {
    gap: var(--sp-12);
  }
  .w-full {
    width: 100%;
  }
  .w-auto {
    width: auto;
  }
  .w-screen {
    width: 100vw;
  }
  .w-0 {
    width: 0;
  }
  .min-w-0 {
    min-width: 0;
  }
  .h-full {
    height: 100%;
  }
  .h-auto {
    height: auto;
  }
  .h-screen {
    height: 100vh;
  }
  .h-fit {
    height: fit-content;
  }
  .h-0 {
    height: 0;
  }
  .min-h-0 {
    min-height: 0;
  }
  .max-h-full {
    max-height: 100%;
  }
  .wh-full {
    width: 100%;
    height: 100%;
  }
  .padding-left-sp-2 {
    padding-left: var(--sp-2);
  }
  .pad-sp-1 {
    padding: var(--sp-1);
  }
  .pad-sp-2 {
    padding: var(--sp-2);
  }
  .pad-sp-3 {
    padding: var(--sp-3);
  }
  .pad-sp-4 {
    padding: var(--sp-4);
  }
  .pad-sp-5 {
    padding: var(--sp-5);
  }
  .margin-inline-start-auto {
    margin-inline-start: auto;
  }

  .shade0 {
    color: var(--shade0);
  }
  .shade1 {
    color: var(--shade1);
  }
  .shade2 {
    color: var(--shade2);
  }
  .shade3 {
    color: var(--shade3);
  }
  .shade4 {
    color: var(--shade4);
  }
  .shade5 {
    color: var(--shade5);
  }
  .shade6 {
    color: var(--shade6);
  }
  .shade7 {
    color: var(--shade7);
  }
  .shade8 {
    color: var(--shade8);
  }
  .shade9 {
    color: var(--shade9);
  }
  .shade10 {
    color: var(--shade10);
  }
  .bg-shade0 {
    background-color: var(--shade0);
  }
  .bg-shade1 {
    background-color: var(--shade1);
  }
  .bg-shade2 {
    background-color: var(--shade2);
  }
  .bg-shade3 {
    background-color: var(--shade3);
  }
  .bg-shade4 {
    background-color: var(--shade4);
  }
  .bg-shade5 {
    background-color: var(--shade5);
  }
  .bg-shade6 {
    background-color: var(--shade6);
  }
  .bg-shade7 {
    background-color: var(--shade7);
  }
  .bg-shade8 {
    background-color: var(--shade8);
  }
  .bg-shade9 {
    background-color: var(--shade9);
  }
  .bg-shade10 {
    background-color: var(--shade10);
  }

  .round {
    border-radius: 50%;
  }

  [data-tip] {
    pointer-events: all;
  }
  [data-tip] > * {
    pointer-events: none;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .preserve-3d,
  .preserve-3d * {
    transform-style: preserve-3d;
  }

  .invis {
    opacity: 0;
    visibility: hidden;
  }

  .visually-hidden {
    ${visuallyHidden}
  }

  .desktop-only {
    ${touchOnly} {
      display: none !important;
    }
  }

  .mobile-only {
    ${mouseOnly} {
      display: none !important;
    }
  }

  ${
    IS_APP
      ? `
        * {
          -webkit-tap-highlight-color: transparent;
        }`
      : `
        ${touchOnly} {
          * {
            -webkit-tap-highlight-color: transparent;
          }
        }`
  }

  @keyframes loading-row {
    0%,
    100% {
      opacity: 0;
      translate: -150% 0;
    }
    20% {
      opacity: 1;
    }
    40%,
    99.9% {
      opacity: 0;
      translate: 150% 0;
    }
  }

  .loading-row {
    position: relative;

    &::after {
      content: "";
      position: absolute;
      inset: 0;
      background: linear-gradient(
        to right,
        transparent,
        var(--shade6-50),
        transparent
      );
      opacity: 0;
      animation: loading-row 3s ease-in-out forwards infinite;
      animation-delay: var(--delay);
      pointer-events: none;
      z-index: 2;
    }
  }
}
`;

// Don't use this, prefer combining the above.
// export default (container: string) => createGlobalStyles`${styles(container)}`;
